import { render, staticRenderFns } from "./AttentionTable.vue?vue&type=template&id=47db5818&scoped=true&"
import script from "./AttentionTable.vue?vue&type=script&lang=js&"
export * from "./AttentionTable.vue?vue&type=script&lang=js&"
import style0 from "./AttentionTable.vue?vue&type=style&index=0&id=47db5818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db5818",
  null
  
)

export default component.exports